import {
    createAsyncSaga,
    name,
    endpoints,
} from '../dependencies'

const fetchTags = createAsyncSaga(
    `${name}/fetchTags`,
    function* ({
        payload: {
            publisherId = null,
        } = {},
        fulfilled,
        rejected,
        request,
    }) {
        try {
            if (!publisherId) {
                throw new Error('publisherId is required')
            }

            const response = yield request({
                method: 'get',
                url: `${endpoints.PICO_API_URL()}/publisher/tags`,
                headers: {
                    publisherid: publisherId,
                },
            })

            const tags = response?.tags || []

            const formattedTags = tags.map((tag: any) => ({
                id: tag?.id,
                editionId: tag?.nfc_edition_id,
                formId: tag?.form_id,
                publisherId: tag?.publisher_id,
                stripeInvoiceId: tag?.stripe_invoice_id,
                tagName: tag?.tag_name,
                gift: tag?.gift,
                impression: tag?.impression,
                customUrl: tag?.custom_url,
                engraving: tag?.engraving,
                shippedDate: tag?.shipped_at,
                deactivatedAt: tag?.deactivated_at,
                orderDate: tag?.created_at,
                updatedAt: tag?.updated_at,
                edition: {
                    id: tag?.edition?.id,
                    stripeProductId: tag?.edition?.stripe_product_id,
                    name: tag?.edition?.name,
                    type: tag?.edition?.type,
                    color: tag?.edition?.color,
                    engravable: tag?.edition?.engravable,
                    trial: tag?.edition?.trial,
                    units: tag?.edition?.units,
                    releasedAt: tag?.edition?.released_at,
                    sold: tag?.edition?.sold,
                    salesChannel: tag?.edition?.sales_channel,
                },
            }))

            yield fulfilled({ tags: formattedTags })
        } catch (error) {

            yield rejected({
                error: error.message,
            })
        }
    }
)

export default fetchTags
